import React from "react";
import { useTraceabilityData } from "./contexts/TraceabilityDataContext";
import { Link } from "react-router-dom";

function CertifiedExcellence() {

  const { brandData } = useTraceabilityData();
  const productName = brandData?.logo?.productName;
  const certifications = [
    {
      img: "img/c1.png",
      text: "Food Safety Management System (ISO 22000 Certified)",
    },
    {
      img: "img/c2.png",
      text: "Regulatory Body FSSAI",
    },
    {
      img: "img/c3.png",
      text: "GCC Countries Halal",
    },
    {
      img: "img/c4.png",
      text: "For Exports APEDA",
    },
    {
      img: "img/c5.png",
      text: "Food Safety System Certification (FSSC 22000)",
    },
  ];
  return (
    <div>
      <div class="wrapper2">
        <h2 class="heading2">Certified for Excellence</h2>
      </div>
      <section class="py-0">
        <div class="container py-0">
          {/* <!-- more blogs --> */}
          <div class="row g-3">
            <div class="col-lg-4 col-12">
              <p class="card-text text-muted py-3 px-2">
                Our {productName} Manufacturing Plant meets the highest
                industry standards, as reflected in the certifications we
                proudly hold. These credentials highlight our dedication to
                producing safe, high-quality, and sustainable products.
              </p>
            </div>
          </div>
        </div>
      </section>
      <div class="bg-light">
        <div class="container p-3">
          <div class="d-flex align-items-center justify-content-between mb-3">
            <h6 class="m-0">Certifications and Compliance</h6>
          </div>
          <div class="row row-cols-xl-5 row-cols-lg-5 row-cols-md-3 row-cols-sm-3 row-cols-2 g-3">
            {certifications.map((item, index) => (

              <div class="product-item col">
                <div class="card h-100 rounded-4 overflow-hidden osahan-card-list">
                  <img src={item.img} alt="" class="card-img-top" />
                  <h6
                    class="fw-normal"
                    style={{
                      fontSize: "12px",
                      textAlign: "center",
                      paddingTop: "10px",
                      color: "black",
                    }}
                  >
                    {item.text}
                  </h6>
                </div>
              </div>

            ))}
          </div>
        </div>
      </div>
      {/* <div class="container p-3">
        <div class="underline2"></div>
      </div>
      <div className="bg-light">
        <div className="container p-3">
          <h6 className="card-title fw-bold my-2">Manufacturing Insights</h6>

          <div className="row row-cols-xl-5 row-cols-lg-5 row-cols-md-2 row-cols-2 g-3">
            <a href="/technology-at-work">
              <div className="product-item col">
                <div className="card h-100 rounded-4 overflow-hidden osahan-card-list">
                  <img src="img/m5-min.png" alt="" className="card-img-top" />
                  <div className="position-absolute text-overlay-f text-white p-3">
                    <h6 className="fw-normal" style={{ fontSize: "15px" }}>
                      <br />
                      Technology At Work
                    </h6>
                  </div>
                </div>
              </div>
            </a>

            <a href="/stringent-quality-testing">
              <div className="product-item col">
                <div className="card h-100 rounded-4 overflow-hidden osahan-card-list">
                  <img src="img/m2-min.png" alt="" className="card-img-top" />
                  <div className="position-absolute text-overlay-f text-white p-3">
                    <h6 className="fw-normal" style={{ fontSize: "14px" }}>
                      <br />
                      Stringent Quality Testing
                    </h6>
                  </div>
                </div>
              </div>
            </a>

            <a href="/certified-for-excellence">
              <div className="product-item col">
                <div className="card h-100 rounded-4 overflow-hidden osahan-card-list">
                  <img src="img/m3-min.png" alt="" className="card-img-top" />
                  <div className="position-absolute text-overlay-f text-white p-3">
                    <h6 className="fw-normal" style={{ fontSize: "15px" }}>
                      <br />
                      Certified for Excellence
                    </h6>
                  </div>
                </div>
              </div>
            </a>

            <a href="/smart-manufacturing">
              <div className="product-item col">
                <div className="card h-100 rounded-4 overflow-hidden osahan-card-list">
                  <img src="img/m4-min.png" alt="" className="card-img-top" />
                  <div
                    className="position-absolute text-overlay-f text-white p-3"
                    style={{ top: "30%" }}
                  >
                    <h6 className="fw-normal" style={{ fontSize: "15px" }}>
                      <br />
                      <br />
                      Smart Manufacturing
                    </h6>
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div> */}
      <div className="flex justify-between mt-10 px-4 mb-4 gap-10 sm:px-0">
        <Link
          to="/stringent-quality-testing"
          className="bg-[#4c922b] text-white py-2 px-6 rounded-lg w-full sm:w-auto inline-block text-center no-underline hover:no-underline"
        >
          Previous
        </Link>
        <Link
          to="/smart-manufacturing"
          className="bg-[#4c922b] text-white py-2 px-6 rounded-lg w-full sm:w-auto inline-block text-center no-underline hover:no-underline"
        >
          Next
        </Link>

      </div>
      {/* <Index /> */}
    </div>
  );
}

export default CertifiedExcellence;
